<!-- 续费月卡接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: { "parkCode":"2KNTYVWC","serialNumber":"21","ticketNo":"21","carCode":"粤Z12345","renewOriginPrice":"3.5","renewFavorPrice":"3","renewValue":"3","month":"1","operator":"operator","operateTime":"2017-03-10 00:00:00","timePeriodList":[{"startTime":"2017-03-28 00:00:00","endTime":"2017-04-01 23:59:59"}],"payOrigin": "3","payOriginRemark": "微信","paymentMode": "0","paymentModeRemark": "0"},
            responseCode: 	{
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台续费某个月卡",
                t_url: this.commonUrls.test+"renewMonthCard",
                p_url: this.commonUrls.prod+"renewMonthCard",
                precondition: "payOrigin、payOriginRemark、paymentMode、paymentModeRemark需要VEMS支持，版本V2.14.1.5以上",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'serialNumber', info2: '否', info3: 'String', info4: '唯一续费流水号，同一次续费流水号唯一，用于多次下发同一续费流水防重' },
                        { info1: 'ticketNo', info2: '否', info3: 'String', info4: '月卡唯一编号' },
                        { info1: 'carCode', info2: '否', info3: 'String', info4: '车牌号，月卡唯一编号和车牌号二选一，如果都传，优先月卡唯一编号。如果一张票有多个车牌且包含续费车牌，也可续费；如果一个车牌有多张不同VIP类型的票，全部续费' },
                        { info1: 'renewOriginPrice', info2: '是', info3: 'Decimal', info4: '续费原金额' },
                        { info1: 'renewFavorPrice', info2: '是', info3: 'Decimal', info4: '续费折后金额' },
                        { info1: 'renewValue', info2: '否', info3: 'Decimal', info4: '续费值，时间类型则忽略，储值类型则为充值金额，次数类型则为充值次数' },
                        { info1: 'month', info2: '否', info3: 'Integer', info4: '续费月数，续费月数、续费时间段至少存在一个，优先续费月数。按月数续费，系统直接在票有效结束时间增加对应月；按时间段续费，则直接对票新增时段。区别：如果一个票已过期一个月，直接按月数续费1个月，续费后票依旧无效；如果按时间段续费，则可自定义时间段，但可能存在时间段和已存在的重叠导致续费不成功' },
                        { info1: 'operator', info2: '是', info3: 'String', info4: '操作员' },
                        { info1: 'operateTime', info2: '是', info3: 'String', info4: '操作时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'timePeriodList', info2: '是', info3: 'JSONArray', info4: '续费时间段' },
                        { info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注' },
                        { info1: 'payOrigin', info2: '否', info3: 'Integer', info4: '支付来源，<url>参考附录:/Api/appendixData</url>' },
                        { info1: 'paymentModeRemark', info2: '否', info3: 'String', info4: '支付方式备注' },
                        { info1: 'paymentMode', info2: '否', info3: 'Integer', info4: '支付方式，<url>参考附录:/Api/appendixData</url>' },

                        ]
                },{
                    titleName: 'timePeriodList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '起始时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间，yyyy-MM-dd HH:mm:ss' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/vip/renewMonthCard.vue